import React, { useState } from "react";
import { Tabs, Tab } from "react-bootstrap";
import ConfigTab from "./ConfigTab";
import { Snackbar } from "@mui/material";
import MuiAlert from "@mui/material/Alert";
import { Setting } from "../../shared/utils/Settings";

const ConfigDashboard = () => {
  const [key, setKey] = useState<string>("tipoAttivita");
  const [notificationOpen, setNotificationOpen] = useState(false);
  const [notificationMessage, setNotificationMessage] = useState("")
  const [notificationSeverity, setNotificationSeverity] = useState("success")
  const [notificationFunctions, setNotificationsFunctions] = useState({
      setErrorMessage: setErrorMessage,
      setSuccessMessage: setSuccessMessage,
      setWarningMessage: setWarningMessage
  })

  
  function setErrorMessage(message: any) {
      setNotificationOpen(true)
      setNotificationSeverity('error')
      setNotificationMessage(message)
  }

  function setSuccessMessage(message: any) {
      setNotificationOpen(true)
      setNotificationSeverity('success')
      setNotificationMessage(message)
  }

  function setWarningMessage(message: any) {
      setNotificationOpen(true)
      setNotificationSeverity('warning')
      setNotificationMessage(message)
  }

  const Alert = React.forwardRef(function Alert(props: any, ref: any) {
      return <MuiAlert elevation={6} ref={ref} {...props} />;
  });

  const handleClose = (event: any, reason: any) => {
      if (reason === 'clickaway') {
          return;
      }
      setNotificationOpen(false);
  };

  return (
    <div className="container mt-4">
      {<Snackbar
          autoHideDuration={Setting.ALERT_TIMEOUT}
          open={notificationOpen}
          onClose={handleClose}
          anchorOrigin={{vertical: 'top', horizontal: 'center'}}>
          <Alert onClose={handleClose} severity={notificationSeverity}>
              {notificationMessage}
          </Alert>
      </Snackbar>}
      <Tabs activeKey={key} onSelect={(k) => setKey(k || "tipoAttivita")} className="mb-3">
        <Tab eventKey="tipoAttivita" title="Tipo attività">
          <ConfigTab title="Tipo Attività" tableName="catTipologiaNegoziazione" notificationFunctions={notificationFunctions}/>
        </Tab>
        <Tab eventKey="tipoStrumentoNegoziato" title="Tipo strumento negoziato">
          <ConfigTab title="Tipo strumento negoziato" tableName="catTipologiaStrumNegoziato" notificationFunctions={notificationFunctions} />
        </Tab>
        <Tab eventKey="naturaSospetto" title="Natura del sospetto">
          <ConfigTab title="Natura del sospetto" tableName="naturaSospetto" notificationFunctions={notificationFunctions}/>
        </Tab>
        <Tab eventKey="autoritaEstere" title="Autorità estere / altre entità">
          <ConfigTab title="Autorità estere / altre entità" tableName="foreignAuth" notificationFunctions={notificationFunctions}/>
        </Tab>
      </Tabs>
    </div>
  );
};

export default ConfigDashboard;




